import { useUserAccount } from '@/api/userAccount';
import { TransactionLink } from '@/components/transactions/TransactionLink';
import { InlineAlert, InlineAlertBody, InlineAlertPrimaryButton } from '@/components/ui/InlineAlert';
import { showUiElementPerIridiumVar } from '@/utils';

export const RecurringCreditsSetupTip = () => {
    const { data: accountData } = useUserAccount();
    const accountIridiumVar = accountData?.data?.user?.accountIridiumVar;
    const isUsingSatelliteCredits = showUiElementPerIridiumVar(accountIridiumVar, 'usesSatelliteCredits');

    if (!isUsingSatelliteCredits) {
        return false;
    }

    return (
        <InlineAlert
            severity="tip"
            title="Set up recurring satellite credits"
            sx={{ mt: 2 }}
            actionButton={
                <InlineAlertPrimaryButton component={TransactionLink} to="/payment/satelliteCredits/recurring">
                    Set up recurring credits
                </InlineAlertPrimaryButton>
            }
        >
            <InlineAlertBody>
                Automatically add credits monthly to ensure
                <br />
                that your telemetry won&apos;t be disrupted.
            </InlineAlertBody>
        </InlineAlert>
    );
};
